import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PremiumCard = ({ children, title, subtitle, icon, onClick, active }) => {
    const theme = useTheme();

    return (
        <Box
            className="glass-card-vanguard animate-fade-in"
            onClick={onClick}
            sx={{
                padding: '28px',
                height: '100%',
                cursor: onClick ? 'pointer' : 'default',
                background: active 
                    ? (theme.palette.mode === 'dark' ? 'rgba(34, 211, 238, 0.1)' : 'rgba(34, 211, 238, 0.05)')
                    : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'),
                backdropFilter: 'blur(24px)',
                border: active 
                    ? `1px solid ${theme.palette.primary.main}` 
                    : `1px solid ${theme.palette.divider}`,
                boxShadow: active 
                    ? (theme.palette.mode === 'dark' ? '0 0 30px rgba(34, 211, 238, 0.15)' : '0 8px 16px rgba(34, 211, 238, 0.1)')
                    : 'none',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    background: active 
                        ? (theme.palette.mode === 'dark' ? 'rgba(34, 211, 238, 0.15)' : 'rgba(34, 211, 238, 0.08)')
                        : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)'),
                    borderColor: 'primary.main',
                    boxShadow: '0 12px 24px rgba(0,0,0,0.1)'
                }
            }}
        >
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                {(title || icon) && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                        <Box>
                            {title && (
                                <Typography 
                                    variant="h6" 
                                    sx={{ 
                                        fontSize: '12px', 
                                        fontWeight: 700,
                                        color: active ? 'primary.main' : 'text.secondary',
                                        textTransform: 'uppercase', 
                                        letterSpacing: '0.1em',
                                        mb: 1
                                    }}
                                >
                                    {title}
                                </Typography>
                            )}
                            {subtitle !== undefined && (
                                <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.02em' }}>
                                    {subtitle}
                                </Typography>
                            )}
                        </Box>
                        {icon && (
                            <Box 
                                sx={{ 
                                    p: 1.5, 
                                    borderRadius: '16px', 
                                    background: active ? 'rgba(34, 211, 238, 0.1)' : 'rgba(255,255,255,0.03)',
                                    color: 'primary.main',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid rgba(34, 211, 238, 0.1)'
                                }}
                            >
                                {icon}
                            </Box>
                        )}
                    </Box>
                )}
                
                {children}
            </Box>
        </Box>
    );
};

export default PremiumCard;
